import { Skeleton } from './ui/skeleton';
import { cn } from '@/lib/utils';

export type SkeletonProps = {
  variant?: 'card' | 'table' | 'text' | 'hub' | 'page';
  rows?: number;
  className?: string;
};

/** Layout-aware loading skeletons matching final page geometry. */
export function PageSkeleton({ variant = 'page', rows = 5, className }: SkeletonProps) {
  if (variant === 'card') {
    return (
      <div className={cn('space-y-3', className)}>
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    );
  }

  if (variant === 'table') {
    return (
      <div className={cn('space-y-2', className)}>
        <Skeleton className="h-10 w-full" />
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  if (variant === 'hub') {
    return (
      <div className={cn('space-y-4', className)}>
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (variant === 'text') {
    return (
      <div className={cn('space-y-2', className)}>
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-4 w-full" />
        ))}
      </div>
    );
  }

  return (
    <div className={cn('space-y-6', className)}>
      <Skeleton className="h-8 w-1/3" />
      <Skeleton className="h-4 w-2/3" />
      <div className="grid gap-4 md:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-28" />
        ))}
      </div>
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
